export var PaymentMethodType;
(function (PaymentMethodType) {
    PaymentMethodType["card"] = "card";
    PaymentMethodType["sbpToken"] = "sbp_token";
})(PaymentMethodType || (PaymentMethodType = {}));
export var BankCardSystem;
(function (BankCardSystem) {
    BankCardSystem["visa"] = "visa";
    BankCardSystem["mastercard"] = "mastercard";
    BankCardSystem["maestro"] = "maestro";
    BankCardSystem["mir"] = "mir";
    BankCardSystem["unknown"] = "unknown";
})(BankCardSystem || (BankCardSystem = {}));
